import { Component, OnInit } from '@angular/core';
import { General_Config } from '../General_Config';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { ActivatedRoute } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  isLoading: boolean = true;
  data: any = null;
  img_base: string = General_Config.image_base;
  constructor(private callNumber: CallNumber, public alertController: AlertController, private activatedRoute: ActivatedRoute, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) {
    General_Config.active_page = 'Profile';
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.loadData();
  }

  loadData() {
    this.restApi.get('shop_profile').subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        this.data = data['data'];
      }
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  makeCall(phno) {
    this.callNumber.callNumber(phno, true)
      .then(res => console.log('Launched dialer!', res))
      .catch(err => console.log('Error launching dialer', err));
  }

}
